import React, { useEffect, useState } from 'react';
import SearchBox from './mainScreenComponents/SearchBox';
import Card from './mainComponents/Card';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from './Main/Header';
import Spinner from './Utils/Spinner';

const MainScreen = () => {
    const [searchResults, setSearchResults] = useState();
    const [searchParams, setSearchParams] = useSearchParams();
    const [isLoading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState();

    const [currentPage, setCurrentPage] = useState(1);
    const query = searchParams.get('search');
    let page = searchParams.get('page');

    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        const url = 'https://api.themoviedb.org/3/search/multi';
        const api_key = 'd0e6107be30f2a3cb0a34ad2a90ceb6f';

        if (!query) {
            axios
                .get('https://api.themoviedb.org/3/movie/popular?api_key=d0e6107be30f2a3cb0a34ad2a90ceb6f&')
                .then((response) => {
                    let data = response.data;
                    let results = response.data.results;
                    let filteredResults = [];
                    const currentDate = new Date();
                    results.forEach((result) => {
                        if (result.media_type === 'movie') {
                            const resultDate = new Date(result.release_date);

                            if (resultDate <= currentDate && result.poster_path) {
                                filteredResults.push(result);
                            }
                        } else {
                            if (result.poster_path) {
                                filteredResults.push(result);
                            }
                        }
                        result.media_type = 'movie';
                    });
                    data.results = filteredResults;
                    setSearchResults(data);

                    setTotalPages(data.total_pages);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false);
                });
        } else {
            setSearchResults();
            if (!page) setCurrentPage(1);
            else setCurrentPage(parseInt(page));

            if (!page) page = 1;
            const fullUrl = `${url}?api_key=${api_key}&query=${query}&page=${page}`;
            axios
                .get(fullUrl)
                .then((response) => {
                    let data = response.data;
                    let results = response.data.results;
                    let filteredResults = [];
                    const currentDate = new Date();
                    results.forEach((result) => {
                        if (result.media_type === 'movie') {
                            const resultDate = new Date(result.release_date);

                            if (resultDate <= currentDate && result.poster_path) {
                                filteredResults.push(result);
                            }
                        } else {
                            if (result.poster_path) {
                                filteredResults.push(result);
                            }
                        }
                    });
                    data.results = filteredResults;
                    setSearchResults(data);

                    setTotalPages(data.total_pages);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false);
                });
        }
    }, [query, page]);

    const handlePaginationClick = (page) => {
        setCurrentPage(page);
        navigate('/?search=' + query + '&page=' + page);
    };

    const renderPaginationButtons = () => {
        const buttons = [];
        const maxDisplayedButtons = 3; // Change this number as per your preference

        // Helper function to calculate the range of displayed buttons
        const calculateButtonRange = () => {
            const halfDisplayed = Math.floor(maxDisplayedButtons / 2);
            let start = currentPage - halfDisplayed;
            let end = currentPage + halfDisplayed;
            if (start <= 0) {
                start = 1;
                end = maxDisplayedButtons;
            }
            if (end > totalPages) {
                end = totalPages;
                start = Math.max(end - maxDisplayedButtons + 1, 1);
            }
            return { start, end };
        };

        // Handle displaying "..." when there are more pages
        const ellipsis = <span key={Math.random()}>...</span>;

        const { start, end } = calculateButtonRange();

        for (let i = start; i <= end; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`btn btn-sm ${i === currentPage ? 'btn-active' : ''}`}
                    onClick={() => handlePaginationClick(i)}
                >
                    {i}
                </button>
            );
        }

        if (start > 1) {
            buttons.unshift(ellipsis);
            buttons.unshift(
                <button
                    key={1}
                    className={`btn btn-sm ${1 === currentPage ? 'btn-active' : ''}`}
                    onClick={() => handlePaginationClick(1)}
                >
                    1
                </button>
            );
        }

        if (end < totalPages) {
            buttons.push(ellipsis);
            buttons.push(
                <button
                    key={totalPages}
                    className={`btn btn-sm ${totalPages === currentPage ? 'btn-active' : ''}`}
                    onClick={() => handlePaginationClick(totalPages)}
                >
                    {totalPages}
                </button>
            );
        }
        return buttons;
    };

    return (
        <div>
            <Header />

            {/* <div className='text-center'>{searchResults && searchResults.total_results + ' results found'}</div> */}
            <div className='grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-4 mt-6'>
                {searchResults &&
                    searchResults.results.map((item, index) => {
                        return (
                            <div key={index} className='flex m-2'>
                                <Card item={item} />
                            </div>
                        );
                    })}
            </div>

            {searchResults && (
                <div className='flex justify-center'>
                    <div className='pagination'>
                        <button
                            className='btn btn-sm'
                            disabled={currentPage === 1}
                            onClick={() => handlePaginationClick(currentPage - 1)}
                        >
                            <svg
                                width='18'
                                height='18'
                                viewBox='0 0 20 20'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    fillRule='evenodd'
                                    clipRule='evenodd'
                                    d='M12.2574 5.59165C11.9324 5.26665 11.4074 5.26665 11.0824 5.59165L7.25742 9.41665C6.93242 9.74165 6.93242 10.2667 7.25742 10.5917L11.0824 14.4167C11.4074 14.7417 11.9324 14.7417 12.2574 14.4167C12.5824 14.0917 12.5824 13.5667 12.2574 13.2417L9.02409 9.99998L12.2574 6.76665C12.5824 6.44165 12.5741 5.90832 12.2574 5.59165Z'
                                    fill='#969696'
                                />
                            </svg>
                        </button>
                        {renderPaginationButtons()}
                        <button
                            className='btn btn-sm'
                            disabled={currentPage === totalPages}
                            onClick={() => handlePaginationClick(currentPage + 1)}
                        >
                            <svg
                                width='18'
                                height='18'
                                viewBox='0 0 20 20'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    fillRule='evenodd'
                                    clipRule='evenodd'
                                    d='M7.74375 5.2448C7.41875 5.5698 7.41875 6.0948 7.74375 6.4198L10.9771 9.65314L7.74375 12.8865C7.41875 13.2115 7.41875 13.7365 7.74375 14.0615C8.06875 14.3865 8.59375 14.3865 8.91875 14.0615L12.7437 10.2365C13.0687 9.91147 13.0687 9.38647 12.7437 9.06147L8.91875 5.23647C8.60208 4.9198 8.06875 4.9198 7.74375 5.2448Z'
                                    fill='#969696'
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            )}
            {isLoading && (
                <div className='h-80 flex justify-center items-center'>
                    <Spinner />
                </div>
            )}
            <div className='h-14'></div>
        </div>
    );
};

export default MainScreen;
